
import { useAuth } from "@/components/auth/AuthProvider";
import GuestEventList from "@/components/event/GuestEventList";
import UserEventList from "@/components/event/UserEventList";
import useFetchingEventTags from "@/hooks/useFetchingEventTags";
import useIsFromBingoCheck from "@/hooks/useIsFromBingoCheck";
import { parseAsString, useQueryState } from "nuqs";

const Events = () => {
  const [selectedTag, setSelectedTag] = useQueryState(
    "tag",
    parseAsString.withOptions({ clearOnDefault: true }).withDefault("")
  );
  
  const { isFromBingo } = useIsFromBingoCheck();

  const {loading: isLoadingAuth, userId, isAuthenticated} = useAuth();
  const { availableTags } = useFetchingEventTags();
  const shouldShowGuestEvents = !isLoadingAuth && !isAuthenticated;
  const shouldShowUserEvents = !isLoadingAuth && isAuthenticated;

  // Updated title
  const displayTitle = "Ready to be inspired?";

  return (
    <div className="p-6 pb-24 max-w-2xl mx-auto animate-fade-in">
      <header className="mb-8 space-y-2">
        <p className="text-xs font-semibold uppercase text-muted-foreground">
          Experiences & gatherings
        </p>
        <h1 className="text-2xl font-bold leading-tight text-foreground">
          {displayTitle}
        </h1>
        <p className="max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
          Cultural experiences. Real conversations. New friends you'll want to see again.
        </p>
      </header>

      {shouldShowGuestEvents && (
        <GuestEventList 
          selectedTag={selectedTag} 
          availableTags={availableTags}
          onSelectTag={setSelectedTag}
          isFromBingo={isFromBingo}
        />
      )}
      {shouldShowUserEvents && (
        <UserEventList 
          selectedTag={selectedTag} 
          userId={userId}
          availableTags={availableTags}
          onSelectTag={setSelectedTag}
          isFromBingo={isFromBingo}
        />
      )}
    </div>
  );
};

export default Events;
